import React from 'react'
import { Route, Routes } from 'react-router-dom'

import PublicRoutes from './Routes/PublicRoutes';
import AdminRoutes from './Routes/AdminRoutes';
import CustomerRouter from './Routes/CustomerRouter';
import CashAppPayCard from './Components/Public/CashApp';

/**
 * 
 * @function Routes
 * @description Router principal de la app
 * @export
 */
export default function rutas(){

	return (
		<Routes>
			<Route path="/*" element={ <PublicRoutes/>}/>
			<Route path="/admin/*" element={<AdminRoutes />} />
			<Route path="/customer/*" element={<CustomerRouter />} />
			{/* <Route path="/a" element={<CashAppPayCard />} /> */}
		</Routes>
	)
}
